import * as React from 'react'

interface NameLabelProps {
  name: string
  answerStyle: {
    answerFontColor: string
    answerFontSize: string
    answerFontFamily: { fontFamily: string }
    width: string
    maxWidth: string
    minHeight: string
    backgroundColor: string
  }
  extraPrice?: React.ReactNode
}

const NameLabel = (props: NameLabelProps) => {
  const { name, answerStyle, extraPrice = null } = props

  const textAnswerStyle = {
    color: answerStyle.answerFontColor,
    fontSize: answerStyle.answerFontSize,
    fontFamily: answerStyle.answerFontFamily?.fontFamily,
    width: answerStyle.width,
    maxWidth: answerStyle.maxWidth,
    minHeight: answerStyle.minHeight,
    backgroundColor: answerStyle.backgroundColor,
  }

  return (
    <label style={textAnswerStyle}>
      <div>{name}</div>
      {extraPrice}
    </label>
  )
}

export default NameLabel
